<div class="design-and-amount-header-container">
    <mat-card-title>Amount</mat-card-title>
</div>
<div
    class="amount-selection-wrapper"
    skeletonData
    [showSkeleton]="!suggestedAmounts?.length"
    [placeholderWidth]="'100%'"
    [placeholderHeight]="'3.125rem'"
>
    <div
        class="amount-selection-dropdown"
        *ngIf="isDropDownVisible() && suggestedAmounts"
    >
        <mat-form-field>
            <mat-select
                [value]="
                    isSuggestedAmount(selectedItemTotal.value)
                        ? selectedItemTotal.value
                        : customAmountDropDownValue
                "
                (valueChange)="
                    selectedItemTotalChanged(
                        $event > customAmountDropDownValue ? $event : null
                    )
                "
                [panelClass]="selector + '-dropdown-panel'"
            >
                <mat-option
                    *ngFor="let itemAmount of suggestedAmounts"
                    [value]="itemAmount"
                >
                    {{ itemAmount | dsiCurrency: true }}
                </mat-option>
                <mat-option [value]="customAmountDropDownValue">
                    Custom
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field
            *ngIf="isCustomAmountSelected()"
            floatLabel="never"
            [ngClass]="{
                'mat-form-field-invalid':
                    selectedItemTotal.touched && selectedItemTotal.invalid
            }"
            class="custom-field"
        >
            <ols-currency-input
                #customAmountButtonInput
                placeholder="$0.00"
                [value]="getCustomAmount()"
                (valueChange)="selectedItemTotalChanged($event)"
                (blur)="amountInputBlurred()"
                (keyup.enter)="submitForm()"
            ></ols-currency-input>
        </mat-form-field>
    </div>
    <div
        class="amount-selection-buttons"
        *ngIf="!isDropDownVisible() && suggestedAmounts"
    >
        <mat-button-toggle-group
            #amountToggleGroup
            [ngClass]="{
                'invalid-toggle-group':
                    selectedItemTotal.touched && selectedItemTotal.invalid
            }"
            [value]="selectedItemTotal.value"
        >
            <mat-button-toggle
                *ngFor="let itemAmount of suggestedAmounts"
                #amountToggle
                color="primary"
                class="ols-mat-stroked-button-color"
                [value]="itemAmount"
                (click)="selectedItemTotalChanged(amountToggle.value)"
            >
                {{ itemAmount | dsiCurrency: true }}
            </mat-button-toggle>
        </mat-button-toggle-group>
        <div
            class="custom-amount-button ols-mat-stroked-button-color"
            [ngClass]="{
                selected:
                    hasFocus(
                        customAmountButtonInput.inputElement.nativeElement
                    ) || isCustomAmountSelected(),
                invalid: selectedItemTotal.touched && selectedItemTotal.invalid
            }"
            skeletonData
            (mousedown)="customAmountClicked()"
            *ngIf="customAmountSettings?.isEnabled"
        >
            <span class="custom-amount-button-label">Custom</span>
            <ols-currency-input
                #customAmountButtonInput
                placeholder="$0.00"
                [selectAllOnFocus]="true"
                [value]="getCustomAmount()"
                (valueChange)="selectedItemTotalChanged($event)"
                (blur)="amountInputBlurred()"
                (keyup.enter)="submitForm()"
            ></ols-currency-input>
        </div>
    </div>
</div>
<mat-error
    class="mat-form-field-subscript-wrapper"
    *ngIf="
        selectedItemTotal.touched &&
        selectedItemTotal.invalid &&
        selectedItemTotal.errors?.required
    "
>
    Amount required
</mat-error>
<mat-error
    class="mat-form-field-subscript-wrapper"
    *ngIf="
        selectedItemTotal.touched &&
        selectedItemTotal.invalid &&
        selectedItemTotal.errors?.currency
    "
>
    Amount invalid
</mat-error>
<mat-error
    class="mat-form-field-subscript-wrapper"
    *ngIf="
        selectedItemTotal.touched &&
        selectedItemTotal.invalid &&
        selectedItemTotal.errors?.min
    "
>
    Amount must be at least
    {{ customAmountSettings.minimum | dsiCurrency: true }}
</mat-error>
<mat-error
    class="mat-form-field-subscript-wrapper"
    *ngIf="
        selectedItemTotal.touched &&
        selectedItemTotal.invalid &&
        selectedItemTotal.errors?.max
    "
>
    Amount cannot exceed
    {{ customAmountSettings.maximum | dsiCurrency: true }}
</mat-error>
